import dayjs from "dayjs";

/**
 * 相対時間を計算して日本語で返す関数
 * @param {Date | string} date 対象の日時
 * @return {string} 相対時間の文字列（例：「3時間前」）
 */
export function timeAgo(date: Date | string): string {
  const now = dayjs();
  const targetDate = dayjs(date);
  const diff = now.diff(targetDate, "second"); // 秒差

  if (diff < 60) return `${diff}秒前`;
  if (diff < 3600) return `${Math.floor(diff / 60)}分前`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}時間前`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}日前`;
  if (diff < 2592000) return `${Math.floor(diff / 604800)}週間前`;
  if (diff < 31536000) return `${Math.floor(diff / 2592000)}カ月前`;
  return `${Math.floor(diff / 31536000)}年前`;
}

/**
 * 絶対日時をフォーマットして返す関数
 * @param {Date | string} date 対象の日時
 * @return {string} フォーマットされた絶対日時（例：「2025/01/15 14:30:25」）
 */
export function formatAbsoluteTime(date: Date | string): string {
  return dayjs(date).format("YYYY/MM/DD HH:mm:ss");
}

/**
 * 短縮日時表記 (MM/DD HH:mm) を返す関数。タイムライン等の狭いカラム向け。
 * @param {Date | string} date 対象の日時
 * @return {string} 短縮日時表記
 */
export function formatShortDateTime(date: Date | string): string {
  return dayjs(date).format("MM/DD HH:mm");
}

/**
 * 相対時間と絶対時間の両方を管理する型
 */
export type TimeDisplay = {
  relative: string;
  absolute: string;
};

/**
 * 相対時間と絶対時間の両方を計算して返す関数
 * @param {Date | string} date 対象の日時
 * @return {TimeDisplay} 相対時間と絶対時間のオブジェクト
 */
export function getTimeDisplay(date: Date | string): TimeDisplay {
  return {
    relative: timeAgo(date),
    absolute: formatAbsoluteTime(date),
  };
}
